import * as _ from 'lodash';
import { letterAndPantsSizes, letterSizeComparator } from 'app/b2b-order/helpers/size';
import { environment } from 'src/environments/environment';

export interface GroupedHeader {
    parentLabel: string;
    childLabels: string[];
    hoverTexts?: string[];
    parentPrefix?: string;
    childPrefix?: string;
}

export function extractNumericFromSize(size: string): number {
    const match = size.match(/\d+/);
    return match ? parseInt(match[0], 10) : 0;
}

export function sizeComparator(a: string, b: string) {
    const numA = Number(a);
    const numB = Number(b);
    const isNumericA = Number.isFinite(numA);
    const isNumericB = Number.isFinite(numB);

    if (isNumericA && isNumericB) {
        return numA - numB;
    }

    if (letterAndPantsSizes.includes(a) && letterAndPantsSizes.includes(b)) {
        return letterSizeComparator(a, b);
    }

    if (!isNumericA && !isNumericB && !environment.production) {
        console.error('[Insights] Unsupported size format:', a, b);
    }

    return extractNumericFromSize(a) - extractNumericFromSize(b);
}

export function sortSizes(sizes: string[]): string[] {
    return _.cloneDeep(sizes).sort((a, b) => {
        if (a.includes('/') && b.includes('/')) {
            const [tokenA1, tokenA2] = a.split('/');
            const [tokenB1, tokenB2] = b.split('/');

            if (tokenA1 === tokenB1) {
                return sizeComparator(tokenA2, tokenB2);
            }
            return sizeComparator(tokenA1, tokenB1);
        }

        return sizeComparator(a, b);
    });
}

/**
 * True if every size label of a size set is 2D (contains `/`), e.g. waist/length `30/32`
 * or 1D e.g. like `S,M`. Used for matrix config (grouped headers) and sizeSet sorting.
 */
export function isTwoDimensionArticle(sizes: string[]): boolean {
    return sizes.length > 0 && sizes.every((size) => size.includes('/'));
}

/**
 * Parent/child header split is a fixed rule, not data-driven: the raw "A/B" size token's
 * first token (A) is always Width (parent, top header row), the second (B) is always
 * Length (child, bottom header row) — matches Figma, regardless of distinct-value counts.
 */
export function splitSizeToken(size: string): { parentSize: string; childSize: string } {
    const [tokenA, tokenB] = size.split('/');
    return { parentSize: tokenA, childSize: tokenB };
}
